export type Coach = {
  name: string
  role: string
  avatar: string
}

/**
 * Fotos de coaches usadas en la fila de prueba del hero y en las reseñas.
 * Texto y fotos son de MUESTRA — reemplazar cada avatar y nombre por el del
 * comprador real antes de lanzar.
 */
export const coaches: Coach[] = [
  {
    name: 'Mike Dalton',
    role: 'Little League coach · Columbus, OH',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/0f2dadee-6275-43ac-aef5-c60e18731158.jpg',
  },
  {
    name: 'Marcus Boyd',
    role: 'Rec league coach · Atlanta, GA',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/855ccdf8-9bc7-449c-b11a-d2496d23c16b.jpg',
  },
  {
    name: 'Dave Ramirez',
    role: 'Volunteer coach, 9-10u · Phoenix, AZ',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/7c39f9c0-1641-41db-827f-87971b1d1409.jpg',
  },
  {
    name: 'Ryan Whitfield',
    role: 'Travel-ball coach · Nashville, TN',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/3290c9f1-5e1d-4679-a9d4-b5de690b833b.jpg',
  },
  {
    name: 'Tom Nguyen',
    role: 'T-ball coach, first season · Sacramento, CA',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/15a21103-cb06-4a96-962d-2f172a8d623c.jpg',
  },
]
